export default {
  meta: {
    title: '岗位管理',
    url: '/organization/post', // 埋点用，记录所属模块
    // eventId: 'a4ffdad0-8037-46a4-9ccd-e255129ec3d0'
  }
};
